import { Vue2AppBuilder } from 'eco-cli'
import App from './src/App.vue'
import { routes } from './src/routes'
import FeedBack from './src/FeedBack.vue'
import { EcoIcon, FlexRow, FlexCol, FlexFill, FlexFixed } from 'eco-page-component'
import { Button, Select, Table, Avatar, Input, FormModel, message, Tooltip, Icon, Divider, Menu, Tabs, Dropdown , Radio,Modal} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'; // or ant-design-vue/dist/antd.less'
import "github-markdown-css/github-markdown.css"
import "@/tools/swiper.min.css"

export default new Vue2AppBuilder()
    .component(App)
    .container('#app')
    .routes(routes)
    .plugins([Button, Radio,Select, Table, Avatar, Input, FormModel, Tooltip, Icon, Divider, Menu, Tabs, Dropdown,Modal, {install(v){
        v.component('EcoIcon', EcoIcon);
        v.component('FlexRow', FlexRow)
        v.component('FlexCol', FlexCol)
        v.component('FlexFill', FlexFill)
        v.component('FlexFixed', FlexFixed)
        v.component('FeedBack', FeedBack)
        v.prototype.$message = message;
    }}])
